import { IconStorage } from "@app/shared/icons/interfaces";

export const arrowNarrowDown: IconStorage = {
  svgCode: () => ([
    "M12 4V20M12 20L18 14M12 20L6 14",
  ]),
};

export const arrowNarrowLeft: IconStorage = {
  svgCode: () => ([
    "M20 12H4M4 12L10 18M4 12L10 6",
  ]),
};

export const arrowNarrowRight: IconStorage = {
  svgCode: () => ([
    "M4 12H20M20 12L14 6M20 12L14 18",
  ]),
};

export const arrowNarrowUp: IconStorage = {
  svgCode: () => ([
    "M12 20V4M12 4L6 10M12 4L18 10",
  ]),
};

export const arrowsHorizontal: IconStorage = {
  svgCode: () => ([
    "M3 21L21 3M3 21H9M3 21L3 15M21 3H15M21 3V9"
  ]),
  svgProps: {
    height: "24",
    style: {
      transform: "rotate(45deg)"
    },
    width: "24",
  }
}

export const arrowsVertical: IconStorage = {
  svgCode: () => ([
    "M3 21L21 3M3 21H9M3 21L3 15M21 3H15M21 3V9",
  ]),
  svgProps: {
    height: "24",
    style: {
      transform: "rotate(-45deg)"
    },
    width: "24",
  }
}